import { Sparkles, MapPin, Phone, Clock } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="rounded-t-[2.5rem] bg-brand-ink py-16 text-white md:py-20">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 md:grid-cols-3 md:px-12">
      <div>
        <div className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-brand-accent" />
          <span className="font-display text-2xl font-semibold tracking-tight">Teo&rsquo;s Nails</span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
          Quality that lasts. Nails that stay perfect — in a friendly, relaxed salon.
        </p>
      </div>
      <div>
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Find us</p>
        <ul className="space-y-4 text-sm text-white/80">
          <li className="flex items-center gap-3" data-testid="footer-address">
            <MapPin className="h-4 w-4 shrink-0 text-brand-accent" />
            <span>Strada General Magheru Nr 30A, Parter, Râmnicu Vâlcea</span>
          </li>
          <li className="flex items-center gap-3" data-testid="footer-phone">
            <Phone className="h-4 w-4 shrink-0 text-brand-accent" />
            <a href="tel:+40745071736" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-white">
              0745 071 736
            </a>
          </li>
          <li className="flex items-center gap-3" data-testid="footer-hours">
            <Clock className="h-4 w-4 shrink-0 text-brand-accent" />
            <span>10:00 – 19:00</span>
          </li>
        </ul>
      </div>
      <div className="flex flex-col justify-between gap-8">
        <div>
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Visit us</p>
          <p className="text-sm leading-relaxed text-white/70">
            The quickest way to book is through the form — tell us what you&rsquo;d like and we&rsquo;ll confirm
            your slot.
          </p>
        </div>
        <a
          href="#booking"
          data-testid="footer-booking-button"
          className="inline-flex w-fit items-center rounded-full bg-brand-accent px-6 py-3 text-sm font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
        >
          Book an appointment
        </a>
      </div>
    </div>
    <div className="mx-auto mt-16 max-w-7xl border-t border-white/10 px-6 pt-8 md:px-12">
      <p className="text-xs text-white/40">Teo&rsquo;s Nails — manicures, pedicures, gel &amp; acrylic nails, and custom nail art.</p>
    </div>
  </footer>
);
